module.exports = __webpack_public_path__ + "media/bgm.71785606.mp3";